module.exports = __webpack_public_path__ + "static/img/200141.900181cf.png";